// FONT AWESOME
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Solid icons

import {
  faAngleLeft,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faBalanceScale,
  faBars,
  faBoxes,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faClock,
  faDollarSign,
  faColumns,
  faExchangeAlt,
  faExclamation,
  faExclamationCircle,
  faEdit,
  faFilter,
  faGripLinesVertical,
  faInfinity,
  faListUl,
  faLongArrowAltLeft,
  faMapMarkerAlt,
  faMinus,
  faMoneyBill,
  faPercentage,
  faPlus,
  faPhone,
  faPrint,
  faTrash,
  faQuestion,
  faSearch,
  faShippingFast,
  faShoppingCart,
  faStoreAlt,
  faThList,
  faTimes,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
library.add(
  faAngleLeft, faArrowLeft, faArrowRight, faArrowUp, faBalanceScale, faBars, faBoxes, faCheck, faCheckCircle, faChevronDown, faChevronLeft, faChevronRight, faClock, faDollarSign, faColumns, faExchangeAlt, faExclamation, faExclamationCircle, faEdit, faFilter, faGripLinesVertical, faInfinity, faListUl, faLongArrowAltLeft, faMapMarkerAlt, faMinus, faMoneyBill, faPercentage, faPlus, faPhone, faPrint, faTrash, faQuestion, faSearch, faShippingFast, faShoppingCart, faStoreAlt, faThList, faTimes, faUser,
);
export default FontAwesomeIcon;
